import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=6f67e644&scoped=true"
import script from "./classification.vue?vue&type=script&lang=js"
export * from "./classification.vue?vue&type=script&lang=js"
import style0 from "./classification.vue?vue&type=style&index=0&id=6f67e644&prod&lang=scss&scoped=true"
import style1 from "./classification.vue?vue&type=style&index=1&id=6f67e644&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67e644",
  null
  
)

export default component.exports